import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SEARCH_QUERY = gql`
  query getSegments($where: SegmentWhereInput, $limit: Int, $offset: Int) {
    segments(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-segment-outlined-select',
  templateUrl: './fc-segment-outlined-select.component.html',
})
export class FcSegmentOutlinedSelectComponent {

  @Input() public label: string;
  @Input() public required: boolean;
  @Input() public control: FormControl;

  constructor(
    public apollo: Apollo,
  ) {}

  public searchSegments(searchTerm: string, limit: number, offset: number): Observable<any[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            archived: false,
            name_contains: searchTerm
          },
          limit: limit,
          offset: offset
        }
      })
      .pipe(
        map(({ data }) => {
          return data['segments']['items'];
        })
      );
  }
}
